import { inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { RouteStore } from 'bernie-core';

import { LodgingPwaPropertySearch, SearchDialogMessage, SearchLinkMessage } from '__generated__/api/types';

import { UitkIcon } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkText } from 'uitk-react-text';

import { LegalDialog } from './legal-dialog';

const LinkTracked = ClickTracker(Link);
const ATracked = ClickTracker('a');

export type HeaderMessageLinkProps = {
  linkName?: string;
  routeStore?: RouteStore;
} & LodgingPwaPropertySearch.ResultsSummary &
  SearchLinkMessage.Fragment &
  SearchDialogMessage.Fragment;

export const HeaderMessageLink: React.FunctionComponent<HeaderMessageLinkProps> = inject('routeStore')(
  ({ icon, link, label, linkName, value, dialogTrigger, routeStore }) => (
    <>
      {dialogTrigger ? (
        <>
          <UitkMoreInfoTrigger type={200}>
            <LinkTracked
              to={`${routeStore.pathname}?${routeStore.mergeQueryString(routeStore.search, { pwaDialog: dialogTrigger.dialogName })}`}
              linkName={value}
              rfrr={dialogTrigger.referrerId}
            >
              <UitkText weight="bold">{value}</UitkText>
              {icon && <UitkIcon name={icon.id} title={label} />}
            </LinkTracked>
          </UitkMoreInfoTrigger>

          <LegalDialog dialogName={dialogTrigger.dialogName} {...dialogTrigger.actionDetails} />
        </>
      ) : (
        <UitkMoreInfoTrigger type={200}>
          <ATracked href={link.url} linkName={linkName || value} rfrr={link.referrerId} target="_blank" rel="noopener">
            <UitkText weight="bold">{value}</UitkText>
            {icon && <UitkIcon name={icon.id} title={label} />}
          </ATracked>
        </UitkMoreInfoTrigger>
      )}
    </>
  )
);
HeaderMessageLink.displayName = 'HeaderMessageLink';
